import * as api from '../../api/equityFinder/regression';
import { makeApiActionCreatorV3 } from '../utils';

export const REGRESSION_ANALYSIS_LIST_FETCH_START =
  'REGRESSION/REGRESSION_ANALYSIS_LIST_FETCH_START';
export const REGRESSION_ANALYSIS_LIST_FETCH_SUCCESS =
  'REGRESSION/REGRESSION_ANALYSIS_LIST_FETCH_SUCCESS';
export const REGRESSION_ANALYSIS_LIST_FETCH_ERROR =
  'REGRESSION/REGRESSION_ANALYSIS_LIST_FETCH_ERROR';

export const REGRESSION_ANALYSIS_DELETE_START =
  'REGRESSION/REGRESSION_ANALYSIS_DELETE_START';
export const REGRESSION_ANALYSIS_DELETE_SUCCESS =
  'REGRESSION/REGRESSION_ANALYSIS_DELETE_SUCCESS';
export const REGRESSION_ANALYSIS_DELETE_ERROR =
  'REGRESSION/REGRESSION_ANALYSIS_DELETE_ERROR';

export const REGRESSION_ANALYSIS_SET_ACTIVE_START =
  'REGRESSION/REGRESSION_ANALYSIS_SET_ACTIVE_START';
export const REGRESSION_ANALYSIS_SET_ACTIVE_SUCCESS =
  'REGRESSION/REGRESSION_ANALYSIS_SET_ACTIVE_SUCCESS';
export const REGRESSION_ANALYSIS_SET_ACTIVE_ERROR =
  'REGRESSION/REGRESSION_ANALYSIS_SET_ACTIVE_ERROR';

export const REGRESSION_ANALYSIS_CREATE_START =
  'REGRESSION/REGRESSION_ANALYSIS_CREATE_START';
export const REGRESSION_ANALYSIS_CREATE_SUCCESS =
  'REGRESSION/REGRESSION_ANALYSIS_CREATE_SUCCESS';
export const REGRESSION_ANALYSIS_CREATE_ERROR =
  'REGRESSION/REGRESSION_ANALYSIS_CREATE_ERROR';

export const REGRESSION_ANALYSIS_PROPERTY_LIST_FETCH_START =
  'REGRESSION/REGRESSION_ANALYSIS_PROPERTY_LIST_FETCH_START';
export const REGRESSION_ANALYSIS_PROPERTY_LIST_FETCH_SUCCESS =
  'REGRESSION/REGRESSION_ANALYSIS_PROPERTY_LIST_FETCH_SUCCESS';
export const REGRESSION_ANALYSIS_PROPERTY_LIST_FETCH_ERROR =
  'REGRESSION/REGRESSION_ANALYSIS_PROPERTY_LIST_FETCH_ERROR';

export const REGRESSION_ANALYSIS_PROPERTY_DELETE_START =
  'REGRESSION/REGRESSION_ANALYSIS_PROPERTY_DELETE_START';
export const REGRESSION_ANALYSIS_PROPERTY_DELETE_SUCCESS =
  'REGRESSION/REGRESSION_ANALYSIS_PROPERTY_DELETE_SUCCESS';
export const REGRESSION_ANALYSIS_PROPERTY_DELETE_ERROR =
  'REGRESSION/REGRESSION_ANALYSIS_PROPERTY_DELETE_ERROR';

export const REGRESSION_ANALYSIS_COMP_PROPERTY_LIST_FETCH_START =
  'REGRESSION/REGRESSION_ANALYSIS_COMP_PROPERTY_LIST_FETCH_START';
export const REGRESSION_ANALYSIS_COMP_PROPERTY_LIST_FETCH_SUCCESS =
  'REGRESSION/REGRESSION_ANALYSIS_COMP_PROPERTY_LIST_FETCH_SUCCESS';
export const REGRESSION_ANALYSIS_COMP_PROPERTY_LIST_FETCH_ERROR =
  'REGRESSION/REGRESSION_ANALYSIS_COMP_PROPERTY_LIST_FETCH_ERROR';

export const REGRESSION_ANALYSIS_COMP_ADD_START =
  'REGRESSION/REGRESSION_ANALYSIS_COMP_ADD_START';
export const REGRESSION_ANALYSIS_COMP_ADD_SUCCESS =
  'REGRESSION/REGRESSION_ANALYSIS_COMP_ADD_SUCCESS';
export const REGRESSION_ANALYSIS_COMP_ADD_ERROR =
  'REGRESSION/REGRESSION_ANALYSIS_COMP_ADD_ERROR';

export const REGRESSION_ANALYSIS_PROPERTY_COMP_SELECT_PROPERTY =
  'REGRESSION/REGRESSION_ANALYSIS_PROPERTY_COMP_SELECT_PROPERTY';
export const REGRESSION_ANALYSIS_PROPERTY_COMP_PROPERTY_CHANGE_CURRENT_PAGE =
  'REGRESSION/REGRESSION_ANALYSIS_PROPERTY_COMP_PROPERTY_CHANGE_CURRENT_PAGE';
export const REGRESSION_ANALYSIS_PROPERTY_COMP_PROPERTY_CHANGE_PAGE_SIZE =
  'REGRESSION/REGRESSION_ANALYSIS_PROPERTY_COMP_PROPERTY_CHANGE_PAGE_SIZE';

export const REGRESSION_ANALYSIS_PROPERTY_COMP_SEARCH_START =
  'REGRESSION/REGRESSION_ANALYSIS_PROPERTY_COMP_SEARCH_START';
export const REGRESSION_ANALYSIS_PROPERTY_COMP_SEARCH_SUCCESS =
  'REGRESSION/REGRESSION_ANALYSIS_PROPERTY_COMP_SEARCH_SUCCESS';
export const REGRESSION_ANALYSIS_PROPERTY_COMP_SEARCH_ERROR =
  'REGRESSION/REGRESSION_ANALYSIS_PROPERTY_COMP_SEARCH_ERROR';

export const REGRESSION_ANALYSIS_RULESET_PROPERTY_FETCH_START =
  'REGRESSION/REGRESSION_ANALYSIS_RULESET_PROPERTY_FETCH_START';
export const REGRESSION_ANALYSIS_RULESET_PROPERTY_FETCH_SUCCESS =
  'REGRESSION/REGRESSION_ANALYSIS_RULESET_PROPERTY_FETCH_SUCCESS';
export const REGRESSION_ANALYSIS_RULESET_PROPERTY_FETCH_ERROR =
  'REGRESSION/REGRESSION_ANALYSIS_RULESET_PROPERTY_FETCH_ERROR';

export const fetchRegressionAnalysisList = makeApiActionCreatorV3(
  api.fetchRegressionAnalysisList,
  REGRESSION_ANALYSIS_LIST_FETCH_START,
  REGRESSION_ANALYSIS_LIST_FETCH_SUCCESS,
  REGRESSION_ANALYSIS_LIST_FETCH_ERROR,
);
export const deleteRegressionAnalysis = makeApiActionCreatorV3(
  api.deleteRegressionAnalysis,
  REGRESSION_ANALYSIS_DELETE_START,
  REGRESSION_ANALYSIS_DELETE_SUCCESS,
  REGRESSION_ANALYSIS_DELETE_ERROR,
);
export const setRegressionAnalysisActive = makeApiActionCreatorV3(
  api.setRegressionAnalysisActive,
  REGRESSION_ANALYSIS_SET_ACTIVE_START,
  REGRESSION_ANALYSIS_SET_ACTIVE_SUCCESS,
  REGRESSION_ANALYSIS_SET_ACTIVE_ERROR,
);
export const createRegressionAnalysis = makeApiActionCreatorV3(
  api.createRegressionAnalysis,
  REGRESSION_ANALYSIS_CREATE_START,
  REGRESSION_ANALYSIS_CREATE_SUCCESS,
  REGRESSION_ANALYSIS_CREATE_ERROR,
);

export const fetchRegressionAnalysisPropertyList = makeApiActionCreatorV3(
  api.fetchRegressionAnalysisPropertyList,
  REGRESSION_ANALYSIS_PROPERTY_LIST_FETCH_START,
  REGRESSION_ANALYSIS_PROPERTY_LIST_FETCH_SUCCESS,
  REGRESSION_ANALYSIS_PROPERTY_LIST_FETCH_ERROR,
);
export const deleteRegressionAnalysisProperty = makeApiActionCreatorV3(
  api.deleteRegressionAnalysisProperty,
  REGRESSION_ANALYSIS_PROPERTY_DELETE_START,
  REGRESSION_ANALYSIS_PROPERTY_DELETE_SUCCESS,
  REGRESSION_ANALYSIS_PROPERTY_DELETE_ERROR,
);

export const fetchRegressionAnalysisPropertyComp = makeApiActionCreatorV3(
  api.fetchRegressionAnalysisPropertyComp,
  REGRESSION_ANALYSIS_COMP_PROPERTY_LIST_FETCH_START,
  REGRESSION_ANALYSIS_COMP_PROPERTY_LIST_FETCH_SUCCESS,
  REGRESSION_ANALYSIS_COMP_PROPERTY_LIST_FETCH_ERROR,
);
export const addRegressionAnalysisPropertyComp = makeApiActionCreatorV3(
  api.addRegressionAnalysisPropertyComp,
  REGRESSION_ANALYSIS_COMP_ADD_START,
  REGRESSION_ANALYSIS_COMP_ADD_SUCCESS,
  REGRESSION_ANALYSIS_COMP_ADD_ERROR,
);

export const searchRegressionAnalysisPropertyComp = makeApiActionCreatorV3(
  api.searchRegressionAnalysisPropertyComp,
  REGRESSION_ANALYSIS_PROPERTY_COMP_SEARCH_START,
  REGRESSION_ANALYSIS_PROPERTY_COMP_SEARCH_SUCCESS,
  REGRESSION_ANALYSIS_PROPERTY_COMP_SEARCH_ERROR,
);
export const fetchRegressionAnalysisRulesetProperty = makeApiActionCreatorV3(
  api.fetchRegressionAnalysisRulesetProperty,
  REGRESSION_ANALYSIS_RULESET_PROPERTY_FETCH_START,
  REGRESSION_ANALYSIS_RULESET_PROPERTY_FETCH_SUCCESS,
  REGRESSION_ANALYSIS_RULESET_PROPERTY_FETCH_ERROR,
);

export function changeAnalysisCompCurrentPage(page) {
  return async dispatch => {
    dispatch({
      type: REGRESSION_ANALYSIS_PROPERTY_COMP_PROPERTY_CHANGE_CURRENT_PAGE,
      data: page,
    });
  };
}

export function changeAnalysisCompPageSize(page) {
  return async dispatch => {
    dispatch({
      type: REGRESSION_ANALYSIS_PROPERTY_COMP_PROPERTY_CHANGE_PAGE_SIZE,
      data: page,
    });
  };
}

export function selectAnalysisCompProperty(propIds) {
  return async dispatch => {
    dispatch({
      type: REGRESSION_ANALYSIS_PROPERTY_COMP_SELECT_PROPERTY,
      data: propIds,
    });
  };
}
